module.exports = __webpack_public_path__ + "media/site/images/logos/industry-tools-logo-c55b0ce6c6c817067bf5c1dca3a9f828.svg";